import { baseApi } from 'segments/api/baseApi';

import { adapteProducts } from '../utils/adapte';

import type {
  UpdateProductParams,
  ProductsListTransformed,
  CreateProductParams,
} from './types';

export const api = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getProductsList: builder.query<ProductsListTransformed, void>({
      query: () => ({
        url: '/admin/products/list',
        method: 'GET',
      }),
      transformResponse: adapteProducts,
      providesTags: ['ProductsList'],
      keepUnusedDataFor: 1,
    }),

    createProduct: builder.mutation<unknown, CreateProductParams>({
      query: (formData: CreateProductParams) => ({
        url: '/admin/products/create',
        method: 'POST',
        body: formData
      }),
      invalidatesTags: ['ProductsList'],
    }),

    deleteProduct: builder.mutation<unknown, number>({
      query: (id: number) => ({
        url: `/admin/products/delete/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ProductsList'],
    }),

    updateProduct: builder.mutation<unknown, UpdateProductParams>({
      query: ({ id, ...formData }: UpdateProductParams) => ({
        url: `/admin/products/update/${id}`,
        method: 'PUT',
        body: formData,
      }),
      invalidatesTags: ['ProductsList'],
    }),
  }),
});

export const {
  useGetProductsListQuery,
  useUpdateProductMutation,
  useDeleteProductMutation,
  useCreateProductMutation
} = api;
